import React from "react";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// REDUX
import { useSelector } from "react-redux";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode } from "@fortawesome/free-solid-svg-icons";
// INTERFACES
import { ButtonInterface } from "../../../interfaces/Components.interface";
import { RootState } from "../../../app/store";

function ButtonSquareCode({ onClick, disabledButton, isLoading }: ButtonInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <Tooltip title="Interface">
        <Button
          className={`${
            disabledButton ? `buttonStyle__inactive__1__${theme}` : ""
          } generalStyles__mlFix`}
          style={{ marginTop: "-5px" }}
          onClick={onClick}
          disabled={disabledButton}
          loading={isLoading}
          icon={<FontAwesomeIcon className="" icon={faCode} />}
        />
      </Tooltip>
    </div>
  );
}

export default ButtonSquareCode;
